import { siteUrl } from './companyInfo'

// Fallback share/structured-data image (a designed 1200x630 image can replace this later).
const DEFAULT_SHARE_IMAGE = `${siteUrl}/og-default.png`

// Human-readable breadcrumb labels for the guide's top-level section routes.
// Keyed by exact pathname; pages not listed here get no breadcrumb.
export const SECTION_LABELS = {
  '/where-to-stay': 'Where to Stay',
  '/eat-drink': 'Eat & Drink',
  '/surf': 'Surf schools & lessons',
  '/beaches-surfing': 'Beaches & Surfing',
  '/surf-forecast': 'Surf forecast',
  '/surf-forecast/selong-belanak-beach': 'Selong Belanak Beach surf forecast',
  '/surf-forecast/mawi-beach': 'Mawi Beach surf forecast',
  '/surf-forecast/serangan-beach': 'Serangan Beach surf forecast',
  '/things-to-do': 'Things to Do',
  '/getting-to-selong-belanak': 'Getting to Selong Belanak',
  '/getting-around': 'Getting Around',
  '/travel-tips': 'Travel Tips',
  '/events-festivals': 'Events & Festivals',
  '/blog': 'Blog',
  '/about': 'About',
  '/contact': 'Contact',
  '/privacy-policy': 'Privacy Policy',
}

// TouristDestination schema describing Selong Belanak (the subject of the whole guide).
// Intentionally neutral — it describes the destination, not any single business.
export const selongBelanakDestination = {
  '@context': 'https://schema.org',
  '@type': 'TouristDestination',
  name: 'Selong Belanak',
  description:
    'Selong Belanak is a white-sand beach and surf destination on the south coast of Lombok, Indonesia — known for its sweeping bay, beginner-friendly waves, nearby surf breaks, and relaxed atmosphere.',
  url: siteUrl,
  image: DEFAULT_SHARE_IMAGE,
  geo: {
    '@type': 'GeoCoordinates',
    latitude: '-8.8679',
    longitude: '116.1400',
  },
  containedInPlace: {
    '@type': 'Place',
    name: 'South Lombok, West Nusa Tenggara, Indonesia',
  },
}

// BreadcrumbList: Home > Section, for a top-level section page.
export const buildBreadcrumb = (sectionName, path) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: siteUrl,
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: sectionName,
      item: `${siteUrl}${path}`,
    },
  ],
})

export const buildArticle = (post, url, imageUrl) => {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: post.title,
    url,
    author: {
      '@type': 'Organization',
      name: 'Selong Belanak Tourism',
      url: siteUrl,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Selong Belanak Tourism',
      url: siteUrl,
    },
  }
  if (post.subtitle) data.description = post.subtitle
  if (imageUrl) data.image = imageUrl
  if (post._createdAt) data.datePublished = post._createdAt
  if (post._updatedAt) data.dateModified = post._updatedAt
  return data
}

export const buildBlogBreadcrumb = (post, url) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: siteUrl,
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Blog',
      item: `${siteUrl}/blog`,
    },
    {
      '@type': 'ListItem',
      position: 3,
      name: post.title,
      item: url,
    },
  ],
})

export const buildLocalBusiness = (listing, url) => {
  const c = listing.contact || {}
  const data = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: listing.location,
    description: listing.tagline || undefined,
    url,
  }
  const sameAs = [listing.links?.website, listing.links?.instagram, listing.links?.facebook].filter(Boolean)
  if (sameAs.length) data.sameAs = sameAs
  if (c.address) data.address = { '@type': 'PostalAddress', streetAddress: c.address }
  if (c.phone) data.telephone = c.phone
  if (c.priceRange && c.priceRange !== 'VERIFY') data.priceRange = c.priceRange
  if (listing.latitude && listing.longitude) {
    data.geo = { '@type': 'GeoCoordinates', latitude: String(listing.latitude), longitude: String(listing.longitude) }
  }
  return data
}
